import React from "react";
import { CustomTitleLabel } from "./CustomBaseComponments";
import CustomTips from "components/base/CustomTips";
import CustomTitleWithInput from "components/base/CustomTitleWithInput";
import MultipleInputWithTitle from "components/base/MultipleInputWithTitle";
import { connect } from "react-redux";
import { capitalizeFirstLetter } from "utils/StringUtil";
import { globalSettingTypeField } from "models/EarningRulesModel";

const GlobalSettingPerMemberSection = ({
  hasEditPermission,
  transactionSources,
  formValue,
  setFormValue,
}) => {
  const globalSettingType = {
    // [globalSettingTypeField.allTime]: "All time",
    [globalSettingTypeField.perDay]: "Per day",
    [globalSettingTypeField.perWeek]: "Per Week",
    [globalSettingTypeField.perMonth]: "Per Month",
    [globalSettingTypeField.perYear]: "Per year",
  }

  const maxTransactionValueInput = (typeFiled) => {
    return (
      <MultipleInputWithTitle
        title={"Max transaction value by source"}
        inputAreaCustomClass={"flex-align-item-end"}
        inputConfig={
          transactionSources.map(source=> ({
            disabled: !hasEditPermission,
            value: formValue?.[typeFiled]?.maxTransactionValueBySource?.[source?.key],
            per: (<div className="d-flex flex-gap-16">
              <div>{`${source?.name || ''} - maximum transaction value:`}</div>
              <div>{"HK$"}</div>
            </div>),
            setValue: (value) => {
              setFormValue({
                ...formValue,
                [typeFiled]: {
                  ...formValue?.[typeFiled],
                  maxTransactionValueBySource: {
                    ...formValue?.[typeFiled]?.maxTransactionValueBySource,
                    [source?.key]: value,
                  }
                }
              })
            },
            customClass: "width-160px",
            type: "number"
          }))
        }
      />
    )
  }
  const rewardsMaxAmountInput = (typeFiled) => (
    <MultipleInputWithTitle
      title={"Max amount of rewards"}
      inputConfig={[
        {
          value: formValue?.[typeFiled]?.maxAmountOfCoupons,
          unit: "Coupons",
          setValue: (value) => {
            setFormValue({ ...formValue, [typeFiled]: { ...formValue?.[typeFiled], maxAmountOfCoupons: value } })
          },
        },
        {
          value: formValue?.[typeFiled]?.maxAmountOfPoints,
          unit: "Points",
          setValue: (value) => {
            setFormValue({ ...formValue, [typeFiled]: { ...formValue?.[typeFiled], maxAmountOfPoints: value } })
          },
        },
        {
          value: formValue?.[typeFiled]?.maxAmountOfPp,
          unit: "Progression points",
          setValue: (value) => {
            setFormValue({ ...formValue, [typeFiled]: { ...formValue?.[typeFiled], maxAmountOfPp: value } })
          },
        },
        {
          value: formValue?.[typeFiled]?.maxAmountOfStamps,
          unit: "Stamps",
          setValue: (value) => {
            setFormValue({ ...formValue, [typeFiled]: { ...formValue?.[typeFiled], maxAmountOfStamps: value } })
          },
        },
      ].map(item => ({ 
        ...item, 
        customClass: "width-160px", 
        type: "number",
        disabled: !hasEditPermission,
       }))}
    />
  )
  return (
    <div className="global-setting-prompt-tab-content">
      <CustomTitleLabel
        title={
          <div className="d-flex">
            {"MAXIMUM REWARD PER MEMBER (OPTIONAL)"}
            <CustomTips
              popoverClassName="tips-popover"
              detail={"When a transaction exceed the maximum reward limit. \nIf the reward is an one-off fixed amount reward, the reward will NOT be issued.\nIf the reward is a dynamic amount reward, the reward will be issued based on the remaining reward quota."}
            />
          </div>
        }
        className={"customer-detail-section-title"}
      />
      <div className="create-section-field-input">
        {"This section allows you to set the global maximum limit for each member. All fields are optional."}
      </div>
      {Object.values(globalSettingTypeField)?.map(fieldName =>
        <div className="create-section-label-bottom-space global-setting-section-container">
          <div className="global-setting-section-title">{globalSettingType?.[fieldName] || ''}</div>
          <div className="global-setting-section-content">
            <CustomTitleWithInput
              type={"number"}
              customClass={"width-160px"}
              useDefaultValue={false}
              defaultValue={formValue?.[fieldName]?.maxTransactionValue}
              title={"Max transaction value"}
              tips={"Please note that a single transaction may trigger multiple earning rules, each applicable to the same transaction value. In such cases, rewards will be issued according to all qualifying earning rules, resulting in a total reward amount that exceeds initial expectations."}
              per={"HK$ "}
              setValue={(value) => {
                setFormValue({ ...formValue, [fieldName]: { ...formValue?.[fieldName], maxTransactionValue: value } })
              }}
              customTitleClass={"create-section-label-no-top-space"}
              disabled={!hasEditPermission}
            />
            {transactionSources?.length > 0 && maxTransactionValueInput(fieldName)}
            {rewardsMaxAmountInput(fieldName)}
          </div>
        </div>
      )}
    </div>
  )
}
const mapPropsToState = (state) => ({
  transactionSources: state.earningRuleList.globalSettingLimitTransactionSources
});

export default connect(mapPropsToState)(GlobalSettingPerMemberSection);
